import { getObjectDiff } from "editor-v3";
import { eHierarchyLevel, eTlfItemType } from "functions/api/enums";
import { TitlesFootnotesReadDto } from "functions/api/tlfItem/TitlesFootnotesReadDto";
import { TlfItemReadDto } from "functions/api/tlfItem/TlfItemReadDto";
import { omitDeep } from "functions/omitDeep";
import { TlfContextProps } from "./interface";

/**
 * Checks if the TLF data has changed compared to the saved version.
 *
 * @param state - The current TLF context state
 * @returns True if there are unsaved changes, false otherwise
 */
export const checkChanged = (state: TlfContextProps) => {
  // Changed memo
  const current: Partial<TlfItemReadDto | TitlesFootnotesReadDto> | null = omitDeep(
    state.tlfDataVersions[state.ixTlfDataVersion],
    ["relationships", "isLocked", "contentProps", "coreTrafficLight"],
  );
  delete current?.comments;
  const saved: Partial<TlfItemReadDto | TitlesFootnotesReadDto> | null | undefined =
    state.ixSaveVersion >= 0
      ? omitDeep(state.tlfDataVersions[state.ixSaveVersion], [
          "relationships",
          "isLocked",
          "contentProps",
          "coreTrafficLight",
        ])
      : undefined;
  delete saved?.comments;
  const changed = getObjectDiff(current, saved);
  // Get changed (unsaved) flag
  state.changed = state.ixTlfDataVersion !== state.ixSaveVersion && changed !== undefined;
  // Check if traffic lights should be hidden initially
  if (
    state.tlfData?.primaryHierarchyLevel === eHierarchyLevel.Report &&
    state.tlfData?.coreTrafficLightSwitch === "DoNotCalculate" &&
    ("tocOriginTrafficLight" in state.tlfData
      ? state.tlfData.tocOriginTrafficLight === "FromScratch" ||
        state.tlfData.tocOriginTrafficLight === "FromBasicLayout" ||
        state.tlfData.type === eTlfItemType.figure ||
        state.tlfData.type === eTlfItemType.v1figure
      : true)
  )
    state.showTrafficLights = false;
};
